var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEducators(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "blog_post",
    "data-name": "blog post",
    width: 40,
    height: 40,
    transform: "translate(1510 1574)",
    fill: "rgba(0,0,0,0.13)"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_95826",
    "data-name": "Mask Group 95826",
    transform: "translate(-1510 -1574)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_172069",
    "data-name": "Group 172069",
    transform: "translate(1517 1582)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_172063",
    "data-name": "Group 172063"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_172061",
    "data-name": "Group 172061",
    transform: "translate(5.1)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_172090",
    "data-name": "Path 172090",
    d: "M10.315,2.58a4.808,4.808,0,1,0,4.8,4.815A4.822,4.822,0,0,0,10.315,2.58Z",
    transform: "translate(-5.5 -2.58)",
    fill: "#E39DFF"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_172062",
    "data-name": "Group 172062",
    transform: "translate(0 9.928)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_172091",
    "data-name": "Path 172091",
    d: "M13.934,10.341,13.6,10.25l-.3.181a3.731,3.731,0,0,1-3.663,0l-.3-.181L9,10.328a10.694,10.694,0,0,0-7.2,5.773l-.246.492.349.44a12.222,12.222,0,0,0,9.552,4.556H11.6V13.5h.88c.013-.039-.013-.078,0-.116a1.664,1.664,0,0,1,1.67-1.514h.155a14.464,14.464,0,0,1,4.724,1.281A10.666,10.666,0,0,0,13.934,10.341Z",
    transform: "translate(-1.56 -10.25)",
    fill: "#E39DFF"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_172068",
    "data-name": "Group 172068",
    transform: "translate(11.338 12.826)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_172064",
    "data-name": "Group 172064",
    transform: "translate(0 1.645)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_172092",
    "data-name": "Path 172092",
    d: "M17.115,15.663V22.38h-4.97a1.823,1.823,0,0,1-1.825-1.825v-6.8h.065A12.825,12.825,0,0,1,17.115,15.663Z",
    transform: "translate(-10.32 -13.76)",
    fill: "#E39DFF"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_172065",
    "data-name": "Group 172065",
    transform: "translate(7.598 1.645)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_172093",
    "data-name": "Path 172093",
    d: "M16.19,15.663V22.38h4.97a1.823,1.823,0,0,0,1.825-1.825v-6.8h-.052A12.837,12.837,0,0,0,16.19,15.663Z",
    transform: "translate(-16.19 -13.76)",
    fill: "#E39DFF"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_172066",
    "data-name": "Group 172066",
    transform: "translate(7.403)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_172094",
    "data-name": "Path 172094",
    d: "M16.429,15a.39.39,0,0,1-.337-.194.4.4,0,0,1,.129-.531,13.008,13.008,0,0,1,5.514-1.786.381.381,0,0,1,.414.349.389.389,0,0,1-.349.414,12.276,12.276,0,0,0-5.19,1.683A.242.242,0,0,1,16.429,15Z",
    transform: "translate(-16.039 -12.489)",
    fill: "#E39DFF"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_172067",
    "data-name": "Group 172067",
    transform: "translate(0.866 0.013)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_172095",
    "data-name": "Path 172095",
    d: "M16.724,15a.365.365,0,0,1-.194-.052,12.276,12.276,0,0,0-5.19-1.683A.383.383,0,1,1,11.4,12.5a12.95,12.95,0,0,1,5.514,1.786.381.381,0,0,1,.129.531A.341.341,0,0,1,16.724,15Z",
    transform: "translate(-10.989 -12.499)",
    fill: "#E39DFF"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEducators);
export default __webpack_public_path__ + "static/media/educators.ed72be1434336148302e53a604d2a731.svg";
export { ForwardRef as ReactComponent };